import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainHeader from "../../shared/MainHeader";
import { GET } from "../../api/ApiService";
import EncryptionHelper from "../../shared/EncryptionHelper";
import { useCallback } from "react";
import debounce from "lodash.debounce";
import moment from "moment";
import {
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import SearchBar from "../../shared/SearchBar";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    // if (page > 1) {
    onPageChange(event, page - 1);
    // }
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div style={{ flexShrink: 0, marginLeft: "2.5rem" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
    </div>
  );
}
const Audit = () => {
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  const fetchData = () => {
    setLoading(true);

    GET(`case/case-audit-log?page=${page + 1}&limit=${rowsPerPage}`)
      .then((resp) => {
        const encryptedData = resp?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);

        console.log("decryptedData of audit log ==> ", decryptedData);
        setAuditData(decryptedData?.data);
        setTotalRows(decryptedData?.total);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAuditSearchValue = useCallback(
    debounce(async (value) => {
      setLoading(true);
      // updates state to trigger display
      try {
        const response = await GET(
          `case/case-audit-log?page=1&limit=${rowsPerPage}&search=${encodeURIComponent(
            value
          )}`
        );
        const encryptedData = response?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);
        console.log("decryptedData Audit Search Result =>", decryptedData);
        setAuditData(decryptedData?.data || []);
        setTotalRows(decryptedData?.total || 0);
        setPage(0); // reset to first page
      } catch (err) {
        toast.error(err?.response?.data?.message || "Search failed");
      } finally {
        setLoading(false);
      }
    }, 800),
    [rowsPerPage]
  );

  return (
    <Box>
      <MainHeader headingText={"Audit log"} />
      <Stack
        gap={3}
        p={4}
        sx={{
          border: "1px solid #C1C1C1",
          minHeight: "80vh",
        }}
      >
        <Stack flexDirection={"row"} justifyContent={"flex-end"} gap={2}>
          <SearchBar
            searchHeight={"40px"}
            placeholder={"Search for case"}
            fullWidth={false}
            searchValue={getAuditSearchValue}
          />
        </Stack>
        {loading ? (
          <Stack justifyContent={"center"} alignItems={"center"} height={400}>
            <CircularProgress />
          </Stack>
        ) : (
          <>
            {auditData?.length > 0 ? (
              <>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Case Name</TableCell>
                        <TableCell>Case Number</TableCell>
                        <TableCell>Modified By</TableCell>
                        <TableCell>Column Name</TableCell>
                        <TableCell>New Value</TableCell>
                        <TableCell>Previous Value</TableCell>
                        <TableCell>Table Name</TableCell>
                        <TableCell>Time Stamp</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {auditData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.CaseName}</TableCell>
                          <TableCell>{item.CaseNumber}</TableCell>
                          <TableCell>{item.ModifiedByUserName}</TableCell>
                          <TableCell>{item.column_name}</TableCell>
                          <TableCell>{item.new_value}</TableCell>
                          <TableCell>{item.previous_value}</TableCell>
                          <TableCell>{item.table_name}</TableCell>
                          <TableCell>
                            {item.timestamp
                              ? moment.utc(item.timestamp).local().format("LLL")
                              : "null"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[100, 250, 900]}
                  component="div"
                  count={totalRows}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </>
            ) : (
              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                height={200}
              >
                No logs found
              </Stack>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
};

export default Audit;
